// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backgroundColor {
  background: #f1fdff;
  padding: 10px;
  border: 1px solid #dedfe1;
}

.table-bg {
  background-color: #fff;
}

.table-bg thead,
.table-bg tbody,
.table-bg tr,
.table-bg td {
  border-color: #dedfe1;
}

.table > :not(:last-child) > :last-child > * {
  border-bottom-color: #dedfe1;
}

.modalClass {
  position: fixed;
  z-index: 99;
  top: 0;
  background: #000000a3;
  width: 100%;
  height: 100%;
  left: 0;
  padding: 6% 0 4% 0;

  th.actions,
  td.actions {
    width: 140px;
  }
}

.modalSubClass {
  background: #ffffff;
  width: 100%;
  border: unset;
  height: auto;
  overflow-x: auto;
  padding: 20px;
  .acb-actions {
    text-align: right;
    display: block;
  }
}

.delbtn {
  cursor: pointer;
}

.advanced-combobox {
  position: relative;
  width: 100%;

  .popupOptions {
    position: absolute;
    z-index: 11;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
    background: #fff;
    border: 1px solid #cccccc;
    border-left: 1px solid #aed1d7;
    border-radius: 6px;
    width: auto;
    overflow: auto;
    min-width: 100%;
    .table {
      border-color: #fff !important;
      margin: 0 !important;
      tr {
        cursor: pointer;
        td {
          padding : 10px;
        }
        &:hover td{
          border-color: #76AEB7 !important;
          background: #76AEB7 !important;
          color: #fff  !important;
          .delbtn  {
            color: #ffffff !important;
          }
        }
      }
    }

    .table-responsive {
      max-height: 300px;
      overflow-y: auto !important;
    }

  }

  .modalSubClass {
    max-width: 90%;
    width: 500px;
  }

  .form-control {
    min-height: 38.19px;
    border-color: #cccccc;
  }

  .ac-result {
    background: #f1fdff;
    max-height: 300px;
    overflow-y: auto;
    position: absolute;
    width: 100%;
    z-index: 11;
  }

  .table {
    border-top: 2px solid #ebedf2;
    background-color: #fff;
    thead th {
      font-weight: bold;
      background-color: #fff !important;
    }
  }

  .nodatafound {
    background: #fff !important;
    border: unset
  }

  .table-responsive {
    overflow: hidden;
  }

  tr.active-row {
    background-color: #f1fdff;
    td,
    input {
      background-color: #f1fdff !important;
    }
  }
}
.inactive-object {
  font-style: italic !important;
  font-size: 7px !important;
}

.advanced-combobox-dropdown {
  .css-1vp9nu5-control {
    border: 1px solid #76aeb7 !important;
    box-shadow: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/AdvancedCombobox/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;;EAElB;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;;EAEX;IACE,kBAAkB;IAClB,WAAW;IACX,yCAAyC;IACzC,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,eAAe;IACf;MACE,6BAA6B;MAC7B,oBAAoB;MACpB;QACE,eAAe;QACf;UACE,cAAc;QAChB;QACA;UACE,gCAAgC;UAChC,8BAA8B;UAC9B,uBAAuB;UACvB;YACE,yBAAyB;UAC3B;QACF;MACF;IACF;;IAEA;MACE,iBAAiB;MACjB,2BAA2B;IAC7B;;EAEF;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB;MACE,iBAAiB;MACjB,iCAAiC;IACnC;EACF;;EAEA;IACE,2BAA2B;IAC3B;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB;;MAEE,oCAAoC;IACtC;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE;IACE,oCAAoC;IACpC,iBAAiB;EACnB;AACF","sourcesContent":[".backgroundColor {\r\n  background: #f1fdff;\r\n  padding: 10px;\r\n  border: 1px solid #dedfe1;\r\n}\r\n\r\n.table-bg {\r\n  background-color: #fff;\r\n}\r\n\r\n.table-bg thead,\r\n.table-bg tbody,\r\n.table-bg tr,\r\n.table-bg td {\r\n  border-color: #dedfe1;\r\n}\r\n\r\n.table > :not(:last-child) > :last-child > * {\r\n  border-bottom-color: #dedfe1;\r\n}\r\n\r\n.modalClass {\r\n  position: fixed;\r\n  z-index: 99;\r\n  top: 0;\r\n  background: #000000a3;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  padding: 6% 0 4% 0;\r\n\r\n  th.actions,\r\n  td.actions {\r\n    width: 140px;\r\n  }\r\n}\r\n\r\n.modalSubClass {\r\n  background: #ffffff;\r\n  width: 100%;\r\n  border: unset;\r\n  height: auto;\r\n  overflow-x: auto;\r\n  padding: 20px;\r\n  .acb-actions {\r\n    text-align: right;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.delbtn {\r\n  cursor: pointer;\r\n}\r\n\r\n.advanced-combobox {\r\n  position: relative;\r\n  width: 100%;\r\n\r\n  .popupOptions {\r\n    position: absolute;\r\n    z-index: 11;\r\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n    background: #fff;\r\n    border: 1px solid #cccccc;\r\n    border-left: 1px solid #aed1d7;\r\n    border-radius: 6px;\r\n    width: auto;\r\n    overflow: auto;\r\n    min-width: 100%;\r\n    .table {\r\n      border-color: #fff !important;\r\n      margin: 0 !important;\r\n      tr {\r\n        cursor: pointer;\r\n        td {\r\n          padding : 10px;\r\n        }\r\n        &:hover td{\r\n          border-color: #76AEB7 !important;\r\n          background: #76AEB7 !important;\r\n          color: #fff  !important;\r\n          .delbtn  {\r\n            color: #ffffff !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .table-responsive {\r\n      max-height: 300px;\r\n      overflow-y: auto !important;\r\n    }\r\n\r\n  }\r\n\r\n  .modalSubClass {\r\n    max-width: 90%;\r\n    width: 500px;\r\n  }\r\n\r\n  .form-control {\r\n    min-height: 38.19px;\r\n    border-color: #cccccc;\r\n  }\r\n\r\n  .ac-result {\r\n    background: #f1fdff;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 11;\r\n  }\r\n\r\n  .table {\r\n    border-top: 2px solid #ebedf2;\r\n    background-color: #fff;\r\n    thead th {\r\n      font-weight: bold;\r\n      background-color: #fff !important;\r\n    }\r\n  }\r\n\r\n  .nodatafound {\r\n    background: #fff !important;\r\n    border: unset\r\n  }\r\n\r\n  .table-responsive {\r\n    overflow: hidden;\r\n  }\r\n\r\n  tr.active-row {\r\n    background-color: #f1fdff;\r\n    td,\r\n    input {\r\n      background-color: #f1fdff !important;\r\n    }\r\n  }\r\n}\r\n.inactive-object {\r\n  font-style: italic !important;\r\n  font-size: 7px !important;\r\n}\r\n\r\n.advanced-combobox-dropdown {\r\n  .css-1vp9nu5-control {\r\n    border: 1px solid #76aeb7 !important;\r\n    box-shadow: unset;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
